"use client";

import { GLOBAL_ANNOUNCEMENT_BANNER_DISMISSED_KEY } from "@/constants";
import { useLocalStorage } from "@/hooks/storage";
import { useDebounce } from "@/hooks/use-debounce";
import type { GlobalAnnouncementConfig } from "@/lib/statsig-configs";

import { Collapsible } from "./collapsible";
import { AnnouncementBannerContent } from "./global-announcement-banner";

export function DismissibleAnnouncementBanner({
  announcement,
}: {
  announcement: GlobalAnnouncementConfig;
}) {
  const [isDismissed, setIsDismissed, isLoading] = useLocalStorage<Record<string, boolean>>(
    GLOBAL_ANNOUNCEMENT_BANNER_DISMISSED_KEY,
    {},
  );

  const handleDismiss = () => {
    setIsDismissed((prev) => ({ ...prev, [announcement.id]: true }));
  };

  const open = !isLoading && !isDismissed[announcement.id];

  // This avoids the banner not following transition on initial mount, so we start as false and then do a true after 5_00 ms
  const debouncedOpen = useDebounce(open, 5_00);

  return (
    <Collapsible open={isDismissed[announcement.id] ? false : debouncedOpen}>
      <Collapsible.Content>
        <AnnouncementBannerContent announcement={announcement} onDismiss={handleDismiss} />
      </Collapsible.Content>
    </Collapsible>
  );
}
